import React, { Component } from 'react';
import { isLoggedIn, fetchSignedMessage, getSessionValue, businessIdHeader, httpOKsuccess, postMethod, cssFormInputLabel, textField, cssFormInput, cssFormInputText, cssError, cssFormInputButton, cssFormCheckBox, userRoleHeader, roleMerchantAdministrator, checkBox, roleAgent, roleMerchant, numberField, buttonType, emailRegularExpression, httpConflict, emailAddressLength, cognitoAttributeLength } from './Library'
import DualBallSpinner from '../img/dual-ball-1s-100px.gif';
import ReactDOM from 'react-dom';
import { NavMenu } from './NavMenu'


export class AddNewUserBusiness extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countrys: [],
			franchiseBusiness: false,
			users: [{ firstName: '', lastName: '', emailAddress: '', franchisor: false, role: roleMerchant, firstNameError: '', lastNameError: '', emailAddressError: '' }],
			loading: true,
			sumbitButtonDisabled: false,
			validated: true
		};
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	async componentDidMount() {
		await isLoggedIn();
		this.setState({ loading: false });
	}


	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.type === 'number' ? parseInt(target.value) : target.value;
		const name = target.name;

		this.setState({
			[name]: value
	});
	}

	handleSubmit = async (event) => {

		event.preventDefault();
		let validated = true;


		for (let i = 0; i < this.state.users.length; i++) {
			if (!this.handleUserValidation(this.state.users[i])) {
				validated = false;
				this.setState({validated: false})
			}
		}
		
		if(validated) {
			var responseLabel = document.getElementById("businessSaveResponse");

			this.setState({ loading: true, sumbitButtonDisabled: true });
			
			var users = [];

			for (let i = 0; i < this.state.users.length; i++) {
				const user = this.state.users[i];
				user.role = user.franchisor ? roleFranchisor : (user.merchantAdministrator ? roleMerchantAdministrator : roleMerchant);
				users.push(user);
			}

			try {

				const response = await fetchSignedMessage(JSON.stringify(users), 'business/' + getSessionValue(businessIdHeader) + '/registerandaddusers', postMethod);

				if (response.status == httpOKsuccess) {
					ReactDOM.render(<label className={cssFormInputLabel}>Users saved succesfully.</label>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				} else if (response.status == httpConflict) {
					ReactDOM.render(<label className={cssFormInputLabel}>Email address is already in use.</label>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				} else {
					ReactDOM.render(<label className={cssFormInputLabel}>Users saving failed. Please try again later.</label>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				}
			}
			catch (error) {
				this.setState({ loading: false, sumbitButtonDisabled: false });
				ReactDOM.render(<label className={cssFormInputLabel}>Users saving failed. Please try again later.</label>, responseLabel)
			}
		}
	}

	handleAddUser = (event) => {
		this.setState({
			users: this.state.users.concat(
				[{ firstName: '', lastName: '', emailAddress: '', franchisor: false, role: roleMerchant }]
			)
		})
	}

	handleUserChange = (elementIndex) => (event) => {
		let users = this.state.users.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.type === numberField ? Number(event.target.value) : event.target.value }
		});

		this.setState({ users });
	}

	handleUserCheckboxChange = (elementIndex) => (event) => {
		let users = this.state.users.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.checked }
		});

		this.setState({ users });
	}

	handleRemoveUser = (elementIndex) => (event) => {
		this.setState({
			users: this.state.users.filter((item, i) => {
				return elementIndex != i
			})
		})
	}


	handleUserValidation(item) {
		let validated = true;

		if (item.firstName.length == 0) {
			validated = false;
			item.firstNameError = "A user requires a first name";
		} else {
			item.firstNameError = "";
		}

		if (item.lastName.length == 0) {
			validated = false;
			item.lastNameError = "A user requires a last name";
		} else {
			item.lastNameError = "";
		}

		if (item.emailAddress.length == 0) {
			item.emailAddressError = "A user requires an email address";
			validated = false;
		} else {
			if (emailRegularExpression.test(item.emailAddress)) {
				item.emailAddressError = "";
			} else {
				validated = false;
				item.emailAddressError = "Email address is not formatted correctly"
			}
		}

		return validated;
	}

	validateItemPropertyContainsText(value, errorProperty, errorDescription) {
		if (value.length == 0) {
			errorProperty = errorDescription;
			return false;
		} else {
			errorProperty = "";
			return true;
		}
	}

	validateTextContainsText(valueToValidate, stateForErrorMessage, errorMessage) {
		if (valueToValidate.length == 0) {
			this.setState({ [stateForErrorMessage]: errorMessage });
			return false;
		} else {
			this.setState({ [stateForErrorMessage]: "" });
			return true;
		}
	}

	user(i, item) {
		return <>
			<label className={cssFormInputLabel}>
				User's first name:
				<input type={textField} name="firstName" onChange={this.handleUserChange(i)} className={cssFormInputText} value={item.firstName} maxLength={cognitoAttributeLength} /><br />
			</label>{item.firstNameError && <p className={cssError} >{item.firstNameError}</p>}
			<label className={cssFormInputLabel}>
				User's last name:
				<input type={textField} name="lastName" onChange={this.handleUserChange(i)} className={cssFormInputText} value={item.lastName} maxLength={cognitoAttributeLength} /><br />
			</label>{item.lastNameError && <p className={cssError} >{item.lastNameError}</p>}
			<label className={cssFormInputLabel}>
				Email Address:
				<input type={textField} name="emailAddress" onChange={this.handleUserChange(i)} className={cssFormInputText} value={item.emailAddress} maxLength={emailAddressLength} /><br />
			</label>{item.emailAddressError && <p className={cssError} >{item.emailAddressError}</p>}
			<div><label className={cssFormInputLabel}><input type={checkBox} className={cssFormCheckBox} name="merchantAdministrator" onChange={this.handleUserCheckboxChange(i)} />Administrator for merchant</label></div>
			{this.state.franchiseBusiness && <div><label className={cssFormInputLabel}><input type={checkBox} className={cssFormCheckBox} name="franchisor" onChange={this.handleUserChange(i)} />Franchisor</label></div>}
			<div><button type={buttonType} className={cssFormInputButton} onClick={this.handleRemoveUser(i)}>Delete</button></div></>
	}


	render() {
		return (<>
			<NavMenu />
			<form onSubmit={this.handleSubmit} className={cssFormInput}>
				{this.state.users.map((item, i) => (
					this.user(i, item)
				))}
				<button type={buttonType} className={cssFormInputButton} onClick={this.handleAddUser }>Add User</button>

				<input type="submit" value="Save Users" className={cssFormInputButton} disabled={this.state.sumbitButtonDisabled} />
			</form>
				{ this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : '' }
			<div id="businessSaveResponse" />
		</>
		);
	}
}
